import { render } from "./DirectionView.vue?vue&type=template&id=33acada8"
import script from "./DirectionView.vue?vue&type=script&lang=js"
export * from "./DirectionView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__